import { AT_UPDATE, IUpdateAction } from './types';
import { IBoardUserMeta } from '../types';

export const updateAction = (
    boardUserMeta: IBoardUserMeta
): IUpdateAction => {
    return {
        type: AT_UPDATE,
        boardUserMeta
    }
};
